import { render, staticRenderFns } from "./LoginRegisterView.vue?vue&type=template&id=22a04636&scoped=true"
import script from "./LoginRegisterView.vue?vue&type=script&lang=js"
export * from "./LoginRegisterView.vue?vue&type=script&lang=js"
import style0 from "./LoginRegisterView.vue?vue&type=style&index=0&id=22a04636&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a04636",
  null
  
)

export default component.exports